var generateStyle = function generateStyle(componentTheme) {
  return {
    matches: {
      display: 'block',
      borderBottom: "".concat(componentTheme.matchesBorder, " ").concat(componentTheme.matchesColor, " solid"),
      paddingBottom: componentTheme.matchesPadding
    },
    addAnswerButtonText: {
      padding: componentTheme.answerButtonTextPadding,
      fontSize: componentTheme.answerButtonTextSize
    }
  };
};
export default generateStyle;